import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';
import { MysqlService } from './../../../../services/mysql.service';
import { SubjectNote } from './../../../../api/subjectNote';
import { SubjectBilling } from './../../../../api/subjectBilling';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from './../../../../../app/services/global-functions.service';

@Component({
  selector: 'app-subject-job-type-change',
  templateUrl: './subject-job-type-change.component.html',
  styleUrls: ['./subject-job-type-change.component.css']
})
export class SubjectJobTypeChangeComponent implements OnInit {

  @Input() subject_id: number;
  @Input() job_id: number;
  @Input() file_number: number;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  subjects: any;
  job_status_run: any;
  job_status_details: any;
  current_job_status_name: any;
  job_status_details_selected: any;
  original_job_status: any;
  job_types: any;
  job_type: any;
  subject_progress: any;
  count_subject_progress: any;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService
  ) {
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.brand_id = this.sessionBrandId;
    // this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();

    // start of job type change
    this.getJobTypes();
  }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      const res = data[0];
     // this.getSubjectNotes(res.subject_id);

     // Need to loop up status
     this.getJobStatusDetails(res.job_status);
    this.getJobStatusDetailsSelected(res.job_status); // load selected first
    this.getJobType(res.job_type_id);


    this.getSubjectProgress(res.job_id, res.file_number)

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => this.job_status_run = res,
      err => console.error(err.status)
    );
}



getJobStatusDetails(job_status_name){
  this._demoService.getJobStatusDetails(job_status_name)
  .subscribe(
    res => {this.job_status_details = res;
      const data = res[0];
      this.original_job_status = data.job_status_name; // set so that we can hide the update button if the job has already been closed.
    
    },
    err => console.error(err.status)
  );

}


getJobStatusDetailsSelected(job_status_name){
  this._demoService.getJobStatusDetails(job_status_name)
  .subscribe(
    res => this.job_status_details_selected = res,
    err => console.error(err.status)
  );

}

updateSubjectStatus(model){
  model.job_id = this.job_id;
  this._demoService.updateSubjectStatus(model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    // this.toastr.success('Subject Status Updated');
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
  this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
  },
    error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Changing Status of Subject');
     return console.log(error);
    }
   // err => console.error(err),
   // () => console.log('done updates')
);}



getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




// this reports as failes but actually works.

newSubjectJobType(model){
  this._demoService.newSubjectJobType(model).subscribe(
    data => { // this.new_subject_data = data; // this is the retuned json upon creation.
    // this.toastr.success('New Subject Job Reference Data Entered');
    // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

     // Setup annd the Currents before we redirec the page
     // Needs to be a Function to update the ObserveOnOperator.
     // this.newCTrace_id(this.latest_trace_id);
     // or this.cdata.changeCTrace_id("999");

   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
   this.gfunc.insertLog_UpdateSubjectNewStageJobType(model);

    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
       return true;


    },
    error => {
    // console.log('Should be form Model' + model);
    // console.error('Error Creating a Trace Project!');
   //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
  //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
  this.gfunc.insertLog_UpdateSubjectNewStageJobType(model);
  this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
     // console.log(Observable.throw(error));
     // return Observable.throw(error);
    }
);


};



// this reports as failes but actually works.
// Need get the last subject numbers first so its easy to caculate at the PHP end.
newSubjectJobTypeAnySubject(model, last_subject_model){

// Maybe calculate and show the next numbers on screen before I create them?
model.count_subject_progress = this.count_subject_progress

  model = {
    ...model,
    last_subject_model: last_subject_model,
  }

  this._demoService.newSubjectJobTypeAnySubject(model).subscribe(
    data => { // this.new_subject_data = data; // this is the retuned json upon creation.
    // this.toastr.success('New Subject Job Reference Data Entered');
    // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

     // Setup annd the Currents before we redirec the page
     // Needs to be a Function to update the ObserveOnOperator.
     // this.newCTrace_id(this.latest_trace_id);
     // or this.cdata.changeCTrace_id("999");

   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

   // changed the log id for this one to be more speficic.
   this.gfunc.insertLog_UpdateSubjectNewStageJobType(model);

    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
       return true;


    },
    error => {
    // console.log('Should be form Model' + model);
    // console.error('Error Creating a Trace Project!');
   //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
  //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
  this.gfunc.insertLog_UpdateSubjectNewStageJobType(model);
  this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
     // console.log(Observable.throw(error));
     // return Observable.throw(error);
    }
);


};




// get job type details.
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { 
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSubjectProgress(job_id, file_number){
  this._demoService.getSubjectProgress(job_id, file_number).subscribe(
    data => { this.subject_progress = data;
      let res = data[0];
      

      this.count_subject_progress = this.subject_progress.length

      // this.load_me_last = 1;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }



}
